module.exports = __webpack_public_path__ + "static/img/tik-tok.e30e471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tik-tok.png
// module id = Gi6I
// module chunks = 1